import Button from '@material-ui/core/Button';
import { DD_LOGS_CONSTS, TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { parseJwt } from 'common/utils/utils';
import Icon from 'components/base/Icon';
import { Flex, Padding, Separator } from 'components/base/layout-components';
import Text from 'components/base/Text';
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { InvitationRequested } from '../InvitationRequested';
import LogoWithDudeWrapper from '../LogoWithDudeWrapper';
import {
  createAccountFromJWT,
  requestInvitation
} from './you-look-familiar.service';

const LineWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 2rem;
  margin-top: 3rem;
`;

const LineText = styled.div`
  position: absolute;
  left: 44%;
  top: -1.7rem;
  background: white;
  padding: 1rem;
`;

export const YouLookFamiliar = ({
  requestInvitationToken,
  createAccountToken,
  toggleModal,
  isForceSsoLogin = false
}) => {
  const [invitationSent, setInvitationSent] = useState(false);
  const history = useHistory();
  useEffect(() => {
    if (requestInvitationToken) {
      const { context } = parseJwt(requestInvitationToken);

      window.addEventListener(
        'load',
        () => {
          TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
            page: TRACKING.PAGES.ONBOARDING,
            page_tab: TRACKING.PAGE_TABS.YOU_LOOK_FAMILIAR,
            context: {
              providerId: context.requesterProviderId,
              orgId: context.requestedOrgId
            }
          });

          window.DD_LOGS &&
            window.DD_LOGS.logger.info(
              DD_LOGS_CONSTS.strayOnBoardings.startedFlow,
              {
                requestedOrgId: context.requestedOrgId,
                requesterProviderId: context.requesterProviderId
              }
            );
        },
        false
      );
    }
  }, []);

  const sendRequest = async () => {
    if (requestInvitationToken) {
      const { context } = parseJwt(requestInvitationToken);

      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.ONBOARDING,
        page_tab: TRACKING.PAGE_TABS.YOU_LOOK_FAMILIAR,
        click_type: TRACKING.CLICK.STRAY_REQUEST_INVITATION,
        context: {
          requestedOrgId: context.requestedOrgId,
          requesterProviderId: context.requesterProviderId
        }
      });

      window.DD_LOGS &&
        window.DD_LOGS.logger.info(
          DD_LOGS_CONSTS.strayOnBoardings.requestInvitation,
          {
            requestedOrgId: context.requestedOrgId,
            requester: context.requesterNameAndEmail,
            requesterProviderId: context.requesterProviderId
          }
        );
    }

    await requestInvitation(requestInvitationToken);
    setInvitationSent(true);
  };

  const createNewCompany = async () => {
    const { params } = parseJwt(createAccountToken);

    TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
      page: TRACKING.PAGES.ONBOARDING,
      page_tab: TRACKING.PAGE_TABS.YOU_LOOK_FAMILIAR,
      click_type: TRACKING.CLICK.STRAY_CREATE_NEW_ORG
    });

    window.DD_LOGS &&
      window.DD_LOGS.logger.info(
        DD_LOGS_CONSTS.strayOnBoardings.createOrganization,
        {
          providerName: params.providerName
        }
      );

    createAccountFromJWT({
      providerName: params.providerName,
      createAccountToken,
      toggleModal,
      history
    });
  };

  return invitationSent ? (
    <InvitationRequested />
  ) : (
    <LogoWithDudeWrapper withDude={false}>
      <Padding t='x-big'></Padding>
      <Icon name='HandIcon' color='orangePeel' size='xxx-large'></Icon>

      <Text size='x-x-x-large' pt='2rem' weight='300'>
        You look familiar!
      </Text>

      <Text
        size='x-large'
        pt='2rem'
        pl='4rem'
        pr='4rem'
        weight='400'
        align='center'
      >
        Are you trying to join an existing account?
      </Text>
      {!isForceSsoLogin && (
        <Padding t='medium' b='x-medium'>
          <Button onClick={sendRequest} variant='contained'>
            Ask for an invitation
          </Button>
        </Padding>
      )}
      <LineWrapper>
        <Separator direction='horizontal' width='100%' height='1px'></Separator>
        <LineText>
          <Text size='large' weight='400'>
            if not:
          </Text>
        </LineText>
      </LineWrapper>
      <Flex direction='column' pt='medium' b='large' items='center'>
        <Icon name='New' size='xx-large' color='orangePeel'></Icon>
        <Text size='x-large' weight='400' align='center' pt='1rem' pb='1.5rem'>
          Set up a new company:
        </Text>
        <Button variant='outlined' size='small' onClick={createNewCompany}>
          SIGN UP
        </Button>
      </Flex>
    </LogoWithDudeWrapper>
  );
};
